export const TERMS_AND_CONDITIONS_URL =
  "https://marbled-oboe-fd5.notion.site/Super-T-Cs-5de47402c9d5415e802af347d14b5c78";
